import { useState, useEffect } from "react";
import { fetchStaticLinkedAccountCount } from "../../../api-client/APIClient";

const CACHE_KEY = "staticLinkedAccountCount";

// Returns the static production linked account count for the org.
// On cache hit (sessionStorage), returns the cached value immediately with no fetch.
// On cache miss, fetches in the background and returns undefined until the response arrives.
const useStaticLinkedAccountCount = (): number | undefined => {
  const [count, setCount] = useState<number | undefined>(() => {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      return cached !== null ? Number(cached) : undefined;
    } catch {
      return undefined;
    }
  });

  useEffect(() => {
    try {
      if (sessionStorage.getItem(CACHE_KEY) !== null) return;
    } catch (e) {
      // sessionStorage unavailable
    }

    fetchStaticLinkedAccountCount((fetched) => {
      setCount(fetched);
      try {
        if (fetched !== undefined) sessionStorage.setItem(CACHE_KEY, String(fetched));
      } catch (e) {
        // sessionStorage unavailable
      }
    });
  }, []);

  return count;
};

export default useStaticLinkedAccountCount;
